import Stage1Player4Room from "../shared/Stage1Player4Room";

export default function Four_Players_Stage1_Player4(props) {
  return <Stage1Player4Room {...props} playerCount={4} hasDrawerRapatriated={true} />;
}